module.exports = __webpack_public_path__ + "static/media/group_icon_blue_bg.609db32b.svg";